/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useTag, useMedia } from '@api/hooks';
import { InfoItem } from '@molecules';
import { getImage } from '@utils/media';

const Item = ({ module, errors }) => {
  const { tag, error } = useTag(module.content.tagId);
  const { media } = useMedia(getImage(module.content));

  const description = error ? 'Error loading tag' : tag.tag || 'loading tag...';

  return (
    <InfoItem.WithError error={errors} size="large" image={media.src} description={description}>
      Latest News Panel
    </InfoItem.WithError>
  );
};

export default Item;
